<script setup>
import {useStore} from "vuex";
import {computed, ref, watch} from "vue";
import {debounce} from "lodash/function";

const store = useStore();
const search = ref('');
const filters = computed(() => store.getters['customers/filters']);

watch(search, debounce(async () => {
  if(search.value !== '' && search.value.length < 3) {
    return;
  }

  store.dispatch('customers/fetchCustomers', {
    ...filters.value,
    search: search.value,
  });
}, 500));

</script>

<template>
  <div class="tw-flex tw-justify-between">
    <div class="tw-w-1/2">
      <label class="tw-border-2 tw-border-grey-mid tw-rounded-md tw-flex tw-text-black">
        <svg-vue
          icon="icons/search"
          class="tw-w-7 tw-h-7 tw-my-2 tw-ml-3 tw-text-grey"
        />
        <input
          v-model="search"
          type="search"
          placeholder="Search"
          class="tw-border-0 tw-w-full tw-pl-3 tw-text-lg"
        >
      </label>
    </div>
  </div>
</template>